import { useFinishedExams } from "src/hooks/useExams";

import DefaultView from "./DefaultView";

export default function FinishedExamsShortView() {
	const { isLoading, data: { rows } = {} } = useFinishedExams({
		orderBy: "updatedAt",
		order: "DESC",
		page: 0,
		take: 2,
	});

	return <DefaultView isLoading={isLoading} rows={rows} rowsToShow={2} />;
}
